import React from 'react';
import './css/User.css'

export default function LogoutPage() {
    return (
      <div className="background">
        <div id="logout-area">
            <p id="logout-message">ログアウトしました</p>
            <div id="to-login">
                <a href="/login/" id="to-login-message">ログインするにはこちら</a>
            </div>
        </div>       
      </div>
    )
}
